export default __webpack_public_path__ + "static/media/ABR_ebook-rev.1.31273572.pdf";